import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ShoppingCart, Menu, X } from 'lucide-react';
import { useCart } from '../context/CartContext';

const LOGO_URL = '/logo-transparent.png';

export const Navigation = () => {
  const { getTotalItems } = useCart();
  const totalItems = getTotalItems();
  const [mobileOpen, setMobileOpen] = useState(false);

  const closeMobile = () => setMobileOpen(false);

  const navLinks = (
    <>
      <Link
        to="/products"
        className="uppercase tracking-[0.2em] text-xs font-body text-brand-green-dark hover:text-brand-gold smooth-transition"
        data-testid="products-link"
        onClick={closeMobile}
      >
        Shop
      </Link>
      <Link
        to="/bulk-orders"
        className="uppercase tracking-[0.2em] text-xs font-body text-brand-green-dark hover:text-brand-gold smooth-transition"
        data-testid="bulk-orders-link"
        onClick={closeMobile}
      >
        Bulk
      </Link>
      <Link
        to="/track-order"
        className="uppercase tracking-[0.2em] text-xs font-body text-brand-green-dark hover:text-brand-gold smooth-transition"
        data-testid="track-order-link"
        onClick={closeMobile}
      >
        Track
      </Link>
      <Link
        to="/about"
        className="uppercase tracking-[0.2em] text-xs font-body text-brand-green-dark hover:text-brand-gold smooth-transition"
        data-testid="about-link"
        onClick={closeMobile}
      >
        About
      </Link>
    </>
  );

  return (
    <nav
      className="fixed top-0 left-0 right-0 z-50 nav-blur bg-brand-cream border-b border-brand-gold/30"
      data-testid="navigation"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-2 flex items-center justify-between">
        <Link
          to="/"
          className="flex items-center group"
          data-testid="logo-link"
          onClick={closeMobile}
        >
          <img
            src={LOGO_URL}
            alt="FarmFreshLily"
            className="h-12 sm:h-16 md:h-20 w-auto object-contain smooth-transition group-hover:opacity-80"
            style={{ mixBlendMode: 'multiply', background: 'transparent' }}
            data-testid="brand-logo"
          />
        </Link>

        {/* Desktop links */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks}
          <Link
            to="/cart"
            className="relative group"
            data-testid="cart-link"
          >
            <ShoppingCart
              className="w-5 h-5 text-brand-green-dark group-hover:text-brand-gold smooth-transition"
              strokeWidth={1.5}
            />
            {totalItems > 0 && (
              <span
                className="absolute -top-2 -right-2 bg-brand-gold text-brand-cream text-xs w-5 h-5 rounded-full flex items-center justify-center font-bold"
                data-testid="cart-count"
              >
                {totalItems}
              </span>
            )}
          </Link>
        </div>

        {/* Mobile controls: cart + hamburger */}
        <div className="flex md:hidden items-center gap-4">
          <Link
            to="/cart"
            className="relative"
            data-testid="cart-link-mobile"
            onClick={closeMobile}
          >
            <ShoppingCart className="w-5 h-5 text-brand-green-dark" strokeWidth={1.5} />
            {totalItems > 0 && (
              <span
                className="absolute -top-2 -right-2 bg-brand-gold text-brand-cream text-xs w-5 h-5 rounded-full flex items-center justify-center font-bold"
                data-testid="cart-count-mobile"
              >
                {totalItems}
              </span>
            )}
          </Link>
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label={mobileOpen ? 'Close menu' : 'Open menu'}
            className="text-brand-green-dark p-1"
            data-testid="mobile-menu-toggle"
          >
            {mobileOpen ? (
              <X className="w-6 h-6" strokeWidth={1.5} />
            ) : (
              <Menu className="w-6 h-6" strokeWidth={1.5} />
            )}
          </button>
        </div>
      </div>

      {/* Mobile menu drawer */}
      {mobileOpen && (
        <div
          className="md:hidden border-t border-brand-gold/30 bg-brand-cream"
          data-testid="mobile-menu"
        >
          <div className="flex flex-col px-6 py-6 gap-5">
            {navLinks}
          </div>
        </div>
      )}
    </nav>
  );
};
